import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 32, className = "", amount = 0.15 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount }}
    transition={{ duration: 0.9, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, light = false, className = "" }) => (
  <p className={`text-[11px] font-medium uppercase tracking-wide2 ${light ? "text-sand/60" : "text-champagne"} ${className}`}>
    {children}
  </p>
);

/* Masked line-by-line reveal on load (hero) */
export const MaskLines = ({ lines, className = "", lineClass = "", delay = 0.15, stagger = 0.14 }) => (
  <span className={`block ${className}`}>
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
        <motion.span
          className={`block will-change-transform ${lineClass}`}
          initial={{ y: "112%" }}
          animate={{ y: 0 }}
          transition={{ duration: 1.1, delay: delay + i * stagger, ease: EASE }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);

/* Masked line-by-line reveal on scroll (sections) */
export const RevealLines = ({ lines, className = "", lineClass = "", stagger = 0.12, amount = 0.3 }) => (
  <motion.span
    className={`block ${className}`}
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true, amount }}
    variants={{ visible: { transition: { staggerChildren: stagger } } }}
  >
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
        <motion.span
          className={`block will-change-transform ${lineClass}`}
          variants={{
            hidden: { y: "112%" },
            visible: { y: 0, transition: { duration: 1, ease: EASE } },
          }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </motion.span>
);
